module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.html
// module id = 73
// module chunks = 0